import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/Button';
import { BookOpen, Target, Lightbulb, Cog, Users, TrendingUp, ArrowRight } from 'lucide-react';
interface CoreCurriculumPageProps {
  onNavigate?: (path: string) => void;
}
export function CoreCurriculumPage({
  onNavigate
}: CoreCurriculumPageProps) {
  const modules = [{
    icon: Target,
    title: 'Module 1: Authority & Personal Brand Positioning',
    description: 'Define your unique voice, positioning, and authority angle in your industry.',
    topics: ['Personal brand audit', 'Competitive positioning', 'Authority statement development', 'Voice & tone guidelines']
  }, {
    icon: BookOpen,
    title: 'Module 2: Content Strategy & Platform Alignment',
    description: 'Match your content to the right platforms for maximum impact and reach.',
    topics: ['Platform selection', 'Content pillars', 'Audience mapping', 'Distribution strategy']
  }, {
    icon: Lightbulb,
    title: 'Module 3: AI-Powered Content Creation',
    description: 'Leverage AI tools while maintaining your authentic voice and brand integrity.',
    topics: ['AI tool selection', 'Prompt engineering', 'Voice preservation', 'Quality control systems']
  }, {
    icon: Cog,
    title: 'Module 4: Content Machines & Idea Generation',
    description: 'Build systems that generate endless content ideas through your custom framework.',
    topics: ['Idea generation systems', 'Content frameworks', 'Batch creation workflows', 'Content calendars']
  }, {
    icon: TrendingUp,
    title: 'Module 5: Consistency Systems',
    description: 'Create workflows that make consistency effortless and sustainable.',
    topics: ['Habit stacking', 'Time blocking', 'Production workflows', 'Automation setup']
  }, {
    icon: Users,
    title: 'Module 6: Accountability Pods',
    description: 'Small groups that keep you on track through structured pressure and feedback.',
    topics: ['Pod formation', 'Check-in systems', 'Peer review protocols', 'Momentum tracking']
  }];
  return <div className="min-h-screen bg-[#f5f5f7] text-[#1f2933]" data-id="element-845">
      <Navbar onNavigate={onNavigate} data-id="element-846" />

      <section className="py-24" data-id="element-847">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-848">
          <div className="text-center mb-16" data-id="element-849">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-850">
              Core Curriculum
            </h1>
            <p className="text-lg font-mono text-[#9ca3af] max-w-2xl mx-auto" data-id="element-851">
              10 comprehensive modules designed to transform you from
              inconsistent creator to authority engine operator
            </p>
          </div>

          <div className="space-y-8 mb-16" data-id="element-852">
            {modules.map((module, idx) => <div key={idx} className="bg-white border-2 border-dashed border-[#9ca3af] p-8 hover:border-salon-red transition-colors" data-id="element-853">
                <div className="flex items-start gap-6" data-id="element-854">
                  <div className="flex-shrink-0" data-id="element-855">
                    <div className="w-12 h-12 bg-salon-red/10 flex items-center justify-center" data-id="element-856">
                      <module.icon className="w-6 h-6 text-salon-red" data-id="element-857" />
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-858">
                    <h3 className="text-xl font-bold mb-3" data-id="element-859">{module.title}</h3>
                    <p className="text-[#1f2933]/80 mb-4" data-id="element-860">
                      {module.description}
                    </p>
                    <div className="flex flex-wrap gap-2" data-id="element-861">
                      {module.topics.map((topic, i) => <span key={i} className="px-3 py-1 bg-[#f5f5f7] border border-[#9ca3af] font-mono text-xs" data-id="element-862">
                          {topic}
                        </span>)}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="text-center bg-white border-2 border-salon-red p-12" data-id="element-863">
            <h2 className="text-2xl font-bold mb-4" data-id="element-864">
              Ready to Start Your Transformation?
            </h2>
            <p className="text-[#9ca3af] font-mono mb-6" data-id="element-865">
              Join The Authority Engine and get access to all 10 modules
            </p>
            <Button size="large" onClick={() => onNavigate && onNavigate('/initiate-access')} className="bg-salon-red hover:bg-salon-red/90 border-salon-red" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-867" />} data-id="element-866">
              INITIATE_ACCESS
            </Button>
          </div>
        </div>
      </section>

      <Footer onNavigate={onNavigate} data-id="element-868" />
    </div>;
}